/** Serialize / restore Joint Decisions chart state for demo encounter decisions. */

export function parseSeriesKey(key) {
  if (!key || typeof key !== 'string') return null;
  const match = key.match(/^(.+)\|L(\d+)$/);
  if (!match) {
    return { procedureKey: key, levels: 0, seriesKey: `${key}|L0` };
  }
  return { procedureKey: match[1], levels: Number(match[2]), seriesKey: key };
}

export function consideredSurgeryFromKey(surgeryKey, label) {
  const parsed = parseSeriesKey(surgeryKey);
  if (!parsed) return null;
  return {
    series_key: parsed.seriesKey,
    procedure_key: parsed.procedureKey,
    levels: parsed.levels,
    ...(label ? { label } : {}),
  };
}

export function seriesKeysFromSurgeries(items) {
  const keys = [];
  const seen = new Set();
  (items || []).forEach((item) => {
    const key = typeof item === 'string'
      ? parseSeriesKey(item)?.seriesKey
      : item?.series_key || parseSeriesKey(item?.procedure_key)?.seriesKey;
    if (!key || seen.has(key)) return;
    seen.add(key);
    keys.push(key);
  });
  return keys;
}

export function buildJointDecisionsDecisionPayload({
  patientId,
  appointmentId,
  encounterDecision,
  decidedProcedureKey,
  decidedSurgeryDate,
  decidedProcedureLabel,
  region,
  pickerLevels,
  characteristics,
  selectedSurgeries,
  reviewedSurgeryKeys,
  viewedChartTabs,
  chartUi,
  encounterNote,
  encounterNoteEdited,
  periopAppointmentId,
  surgeryLabelForKey,
} = {}) {
  const labelFor = (key) => {
    if (typeof surgeryLabelForKey === 'function') {
      return surgeryLabelForKey(key);
    }
    return undefined;
  };
  const considered = (selectedSurgeries || [])
    .map((key) => consideredSurgeryFromKey(key, labelFor(key)))
    .filter(Boolean);
  const reviewedSource = (reviewedSurgeryKeys || []).length
    ? reviewedSurgeryKeys
    : selectedSurgeries;
  const reviewed = (reviewedSource || [])
    .map((key) => consideredSurgeryFromKey(key, labelFor(key)))
    .filter(Boolean);

  return {
    patient_id: patientId,
    appointment_id: appointmentId,
    encounter_decision: encounterDecision,
    decided_procedure_key: decidedProcedureKey || null,
    decided_surgery_date: decidedSurgeryDate || null,
    decided_procedure_label: decidedProcedureLabel || null,
    region,
    picker_levels: pickerLevels == null || pickerLevels === '' ? null : Number(pickerLevels),
    characteristics: characteristics || {},
    considered_surgeries: considered,
    reviewed_surgeries: reviewed,
    viewed_chart_tabs: viewedChartTabs || [],
    chart_ui: chartUi || {},
    encounter_note: encounterNote || '',
    encounter_note_edited: Boolean(encounterNoteEdited),
    periop_appointment_id: periopAppointmentId || '0',
  };
}
